<template>
  <div style="overflow-x: auto; overflow-y: hidden; padding: 14px; margin: 6px 0">
    <div v-if="items && items.length > 0">
      <chart-sorter v-model="sorting" :sorting-items="sortingItems" />

      <div class="chart-container" :style="{ width: width }">
        <bar-chart ref="barChart" :chart-data="chartData" :options="chartOptions" />
      </div>
    </div>
    <chart-empty-state v-else />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { localeString } from '@/config/helpers.js'
import BarChart from '@/components/BarChart.vue'
import { splitUnitName, filterUnit, removeCommonElement } from '@/modules/industria/helpers/chartHelper.js'
import ChartSorter from './ChartSorter.vue'
import ChartEmptyState from '@/components/campaigns/ChartEmptyState.vue'

export default {
  name: 'ClientsDiscountChart',
  components: {
    BarChart,
    ChartSorter,
    ChartEmptyState,
  },
  props: {
    selectedUnits: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      default(_) {
        return []
      },
    },
    offerType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    sorting: 'de-desc',
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              labelOffset: 10,
              beginAtZero: true,
              callback: (value, index, values) => {
                return `R$ ${localeString(value, 2)}`
              },
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          title: (tooltipItem, data) => {
            return tooltipItem[0].xLabel.join(' ')
          },
          label: (tooltipItem, data) => {
            return [`Desconto de: R$ ${localeString(tooltipItem.yLabel)}`, `Clientes: ${localeString(data.datasets[1].data[tooltipItem.index])}`]
          },
        },
      },
      layout: {
        padding: {
          top: 30,
        },
      },
      plugins: {
        datalabels: {
          clamp: true,
          anchor: 'end',
          align: 'top',
          offset: 0,
          textAlign: 'center',
          formatter: (value, context) => {
            return [`R$ ${localeString(value, 2)}`, `(${localeString(context.chart.data.datasets[1].data[context.dataIndex])})`]
          },
        },
      },
    },
  }),
  computed: {
    chartData() {
      let itemsClone = cloneDeep(this.items)
      const units = []
      const discounts = []
      const numberOfClients = []

      switch (this.sorting) {
        case 'de-asc':
          itemsClone.sort((a, b) => a.offer_discount - b.offer_discount)
          break
        case 'de-desc':
          itemsClone.sort((a, b) => b.offer_discount - a.offer_discount)
          break
        case 'none':
        default:
          itemsClone = cloneDeep(this.items)
      }

      itemsClone = filterUnit(itemsClone, this.selectedUnits)
      itemsClone.forEach((item) => {
        units.push(splitUnitName(item.unit_name))
        discounts.push(item.offer_discount)
        numberOfClients.push(item.clients_with_discount)
      })

      let datasets = [
        {
          label: 'Desconto em R$',
          data: discounts,
          backgroundColor: '#002040',
        },
        {
          label: 'Número de Clientes',
          data: numberOfClients,
          hidden: true,
          datalabels: {
            display: false,
          },
        },
      ]

      removeCommonElement(units)
      return {
        labels: units,
        datasets,
      }
    },

    sortingItems() {
      return [
        {
          sortBy: 'de',
          name: 'Desconto aplicado (Clientes)',
          legendColor: '#002040',
        },
      ]
    },

    width() {
      return this.chartData.datasets[0].data.length * 100 + 'px'
    },

    isCrossSell() {
      return this.offerType === 'crosssell'
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  position: relative;
  min-width: 100%;
}
</style>
